import { render, staticRenderFns } from "./B1_Header.vue?vue&type=template&id=70e88674&scoped=true&"
import script from "./B1_Header.vue?vue&type=script&lang=js&"
export * from "./B1_Header.vue?vue&type=script&lang=js&"
import style0 from "./B1_Header.vue?vue&type=style&index=0&id=70e88674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e88674",
  null
  
)

component.options.__file = "B1_Header.vue"
export default component.exports